import {AbstractControl, ValidatorFn} from '@angular/forms';

import {OnlyDigitsValidatorKey} from './custom-validator-keys';

export function OnlyDigitsValidator(checkControl = true, value?: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = !checkControl ? value : control.value;

        if (!controlValue) {
            return null;
        }

        return !/^[0-9\s]+$/.test(controlValue) ? {[OnlyDigitsValidatorKey]: true} : null;
    };
}
